/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Audit_Event_Outreach_Email_Sent18Inputs */

const en_coinvestments_audit_event_outreach_email_sent18 = /** @type {(inputs: Coinvestments_Audit_Event_Outreach_Email_Sent18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outreach Email Sent`)
};

/**
* | output |
* | --- |
* | "Outreach Email Sent" |
*
* @param {Coinvestments_Audit_Event_Outreach_Email_Sent18Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_audit_event_outreach_email_sent18 = /** @type {((inputs?: Coinvestments_Audit_Event_Outreach_Email_Sent18Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Audit_Event_Outreach_Email_Sent18Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_audit_event_outreach_email_sent18(inputs)
});
export { coinvestments_audit_event_outreach_email_sent18 as "coInvestments_audit_event_OUTREACH_EMAIL_SENT" }